export const Types = {
    GET_EQUIPMENT_REPORT_LIST: "GET_EQUIPMENT_REPORT_LIST",
    SET_EQUIPMENT_REPORT_LIST: "SET_EQUIPMENT_REPORT_LIST",
    ADD_EQUIPMENT_REPORT: "ADD_EQUIPMENT_REPORT",
    UPDATE_EQUIPMENT_REPORT: "UPDATE_EQUIPMENT_REPORT",
    DELETE_EQUIPMENT_REPORT: "DELETE_EQUIPMENT_REPORT",
    IS_UPDATED_TASK: "IS_UPDATED_TASK",
    RESET_IS_UPDATED_TASK: "RESET_IS_UPDATED_TASK",
    GET_PLANTS: "GET_PLANTS",
    SET_PLANTS: "SET_PLANTS",
};

export const getEquipmentReportList = () => ({
    type: Types.GET_EQUIPMENT_REPORT_LIST,
});

export const setEquipmentReportList = (payload) => (
    {
    type: Types.SET_EQUIPMENT_REPORT_LIST,
    payload: payload,
}
);

export const addEquipmentReport = (payload) => {
    return {
        type: Types.ADD_EQUIPMENT_REPORT,
        payload: payload,
    };
};

export const updateEquipmentReport = (payload) => {
    return {
        type: Types.UPDATE_EQUIPMENT_REPORT,
        payload: payload,
    };
};

export const deleteEquipmentReport = (payload) => {
    return {
        type: Types.DELETE_EQUIPMENT_REPORT,
        payload: payload,
    };
};

export const getPlants = () => ({
    type: Types.GET_PLANTS,
});

export const setPlants = (payload) => ({
    type: Types.SET_PLANTS,
    payload: payload,
});

export const isUpdateTask = (payload) => ({
    type: Types.IS_UPDATED_TASK,
    payload,
});

export const resetIsUpdateTask = (payload) => ({
    type: Types.RESET_IS_UPDATED_TASK,
    payload,
});
